module.exports = __webpack_public_path__ + "static/9heartwarminggames1-98ecef001efa5c3c6408c904736dbee7.png";